<template>
  <div class="common-box">
    <slot name="title">
      <TitleBar v-bind="$attrs" />
    </slot>
    <div class="common-content">
      <slot>
        <!-- content -->
      </slot>
    </div>
  </div>
</template>

<script>
import TitleBar from "./TitleBar.vue"
export default {
  name: "ComBox",
  components: {
    TitleBar
  },
  inheritAttrs: false,
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="less">
.common-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .common-content {
    width: 100%;
    height: 0;
    flex: auto;
  }
}
</style>
